import React from 'react'

export interface IIconSmArrowUp {}

export default function IconSmArrowUp() {
  return (
    <svg
      className="h-2.5 w-2.5"
      viewBox="0 0 29 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="fill-brij-Mud"
        d="M1.18591 11.53L11.5459 1.17C13.1059 -0.39 15.6259 -0.39 17.1859 1.17L27.5459 11.53C30.0659 14.05 28.2659 18.37 24.7059 18.37H3.98591C0.425908 18.37 -1.33409 14.05 1.18591 11.53Z"
      />
    </svg>
  )
}
